/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cert_TInputs */

const en_cp_cert_t = /** @type {(inputs: Cp_Cert_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A certificate that names skills`)
};

const id_cp_cert_t = /** @type {(inputs: Cp_Cert_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertifikat yang menyebut skill`)
};

/**
* | output |
* | --- |
* | "A certificate that names skills" |
*
* @param {Cp_Cert_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cert_t = /** @type {((inputs?: Cp_Cert_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cert_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cert_t(inputs)
	return en_cp_cert_t(inputs)
});